"use client";

import { useEffect } from "react";

const LOCALE_COOKIE_KEY = "preferred_locale";
const RTL_LOCALES = new Set(["ar", "he", "fa", "ur"]);

export function LangSetter({ lang }: { lang: string }) {
  useEffect(() => {
    document.documentElement.lang = lang;
    document.documentElement.dir = RTL_LOCALES.has(lang) ? "rtl" : "ltr";
    document.cookie = `${LOCALE_COOKIE_KEY}=${lang}; Path=/; Max-Age=31536000; SameSite=Lax`;
  }, [lang]);

  return null;
}
